import React, { useCallback } from 'react';
import { MultiSelect } from '@components/common';
import { IShare, IResource } from '../../../types';

interface IProps {
  share: IShare;
  resources: IResource[];
  setShare: (sid: number, s: IShare) => void;
}

const EditableResource: React.FC<IProps> = ({ share, resources, setShare }) => {
  const onChange = useCallback(
    (newResources) => {
      const data = newResources.map((name) => resources.filter((r) => r.name === name)[0].id);
      share.resources = data;
      setShare(share.id, share);
    },
    [setShare, share.id],
  );

  return (
    <MultiSelect
      placeholder="Add resource..."
      style={{ width: '100%', minWidth: '524px', maxWidth: '524px' }}
      defaultValues={share.resources.map((rid) => resources.filter((r) => r.id === rid)[0].name)}
      onChange={onChange}
      options={resources.map((r) => r.name)}
      draggable
    />
  );
};

export default EditableResource;
